import React from "react";
import { Card } from "../card";

export function TableSkeleton() {
  return (
    <div>
      <div className="flex items-center justify-between pt-2 lg:pt-2 pb-4">
        <div className="h-3 mt-5 lg:mt-0 bg-secondary opacity-10 rounded-full w-20 mb-2.5"></div>
        <div className="w-28 h-8 rounded-md bg-secondary opacity-10"></div>
      </div>
      <Card>
        {Array.from({ length: 8 }, (_, index) => (
          <div
            key={index}
            className="max-w-screen-xl mx-auto space-y-4 animate-pulse">
            <div className="flex items-center justify-between px-3 py-6">
              <div>
                <div className="h-2 bg-secondary opacity-20 rounded-full dark:bg-gray-600 w-24 mb-2"></div>
                <div className="w-32 h-1.5 bg-secondary opacity-10 rounded-full"></div>
              </div>
              <div className="hidden lg:flex h-2 bg-secondary opacity-20 rounded-full w-12"></div>
              <div className="hidden lg:flex h-2 bg-secondary opacity-20 rounded-full w-12"></div>
              <div className="h-2 bg-secondary opacity-20 rounded-full w-12"></div>
            </div>
            <span className="sr-only">Loading...</span>
          </div>
        ))}
      </Card>
    </div>
  );
}
